import { render, staticRenderFns } from "./PeopleTable.vue?vue&type=template&id=6636cb82&scoped=true&"
import script from "./PeopleTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./PeopleTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PeopleTable.vue?vue&type=style&index=0&id=6636cb82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636cb82",
  null
  
)

export default component.exports